import { Icon } from '@rbilabs/universal-components';

import { primitive } from 'styles/constants/primitives';

export * from 'pages/cart/details/base.styled';

export const IconStyled = Icon.withConfig(props => ({
  size: 5,
  marginRight: '$1',
  color: props.disabled ? primitive.$blackOpacity50 : primitive.bk.$bbqBrown,
}));
